import ProInfluencerIcon from "@/assets/images/pro_influencer.svg?react";
import ProInfluencerLabelledIcon from "@/assets/images/pro_influencer_labelled.svg?react";
import {Tooltip} from "@/components/Common/Tooltip";
import clsxm from "@/lib/clsxm";
import {useId, type FC} from "react";
import {useTranslation} from "react-i18next";

const ProInfluencerBadge: FC<{className?: string; tooltipDisabled?: boolean; labelled?: boolean}> = ({
  className,
  labelled,
  tooltipDisabled = false,
}) => {
  const {t} = useTranslation("influencer_profile");
  const id = useId();

  return (
    <>
      <div data-tooltip-id={`pro-badge-${id}`}>
        {labelled ? (
          <ProInfluencerLabelledIcon className={clsxm("h-4 w-10.5 shrink-0 rounded-full", className)} />
        ) : (
          <ProInfluencerIcon
            className={clsxm("size-4 shrink-0 rounded-full", !tooltipDisabled && "cursor-pointer", className)}
          />
        )}
      </div>
      <Tooltip
        id={`pro-badge-${id}`}
        clickable
        disableTooltip={() => tooltipDisabled}
        place="right"
        variant="light"
        opacity={1}
        delayShow={200}
        className="z-100 max-w-72 p-3 shadow-md"
        classNameArrow="shadow-md">
        <div className="flex flex-col gap-1.5">
          <div className="flex items-center gap-1">
            <ProInfluencerIcon className={clsxm("size-4 shrink-0 rounded-full", className)} />
            <span className="text-neutral-black text-sm font-semibold">{t("pro_influencer_tooltip_title")}</span>
          </div>
          <span className="text-neutral-grey-dark text-left text-xs">{t("pro_influencer_tooltip_description")}</span>
        </div>
      </Tooltip>
    </>
  );
};

export default ProInfluencerBadge;
